// extracted by mini-css-extract-plugin
export default {"description":"oqui8"};